import { useState } from "react"
import { Link } from "react-router"
import { useToast } from "@/client/components/common/toast"
import { getBrowserSupabaseClient } from "@/lib/supabase/client"
import { resetPassword } from "@/lib/supabase/auth"
import styles from "./forgot-password-page.module.css"

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState("")
  const [sending, setSending] = useState(false)
  const [sent, setSent] = useState(false)
  const toast = useToast()

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault()
    if (sending) return

    const supabase = getBrowserSupabaseClient()
    if (!supabase) {
      toast.error("系统未配置")
      return
    }

    setSending(true)
    const result = await resetPassword(supabase, email)
    setSending(false)

    if (result.error) {
      toast.error(result.error)
      return
    }

    setSent(true)
    toast.success("重置邮件已发送")
  }

  return (
    <div className={styles.page}>
      <div className={styles.header}>
        <h1 className={styles.title}>找回密码</h1>
        <p className={styles.subtitle}>
          {sent ? "邮件已发送，请查收" : "输入注册邮箱，我们将发送重置链接"}
        </p>
      </div>

      {!sent ? (
        <form className={styles.form} onSubmit={handleSubmit}>
          <div className={styles.inputGroup}>
            <label className={styles.label}>邮箱地址</label>
            <div className={styles.inputWrapper}>
              <svg className={styles.inputIcon} width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                <path d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
              </svg>
              <input
                className={styles.input}
                type="email"
                placeholder="请输入注册邮箱"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                autoFocus
              />
            </div>
          </div>

          <button className={styles.submitBtn} type="submit" disabled={sending}>
            {sending ? "发送中..." : "发送重置链接"}
          </button>
        </form>
      ) : (
        <div className={styles.success}>
          <div className={styles.successIcon}>
            <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
            </svg>
          </div>
          <p className={styles.successText}>
            重置链接已发送至 <strong>{email}</strong>
          </p>
          <p className={styles.successHint}>请检查邮箱（含垃圾邮件），点击链接重置密码</p>
          <button className={styles.resendBtn} onClick={handleSubmit} disabled={sending}>
            重新发送
          </button>
        </div>
      )}

      <div className={styles.footer}>
        <Link to="/login" className={styles.backLink}>
          ← 返回登录
        </Link>
      </div>
    </div>
  )
}
